// extracted by mini-css-extract-plugin
export default {"wrapper":"fallguysalternative_wrapper__rCwE9","button":"fallguysalternative_button__t54OD"};